import InvoicesTable from './InvoicesTable';

export default InvoicesTable;
